module.exports = {
	"about": [
		{
			"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
			"title": "about .radio",
			"video": "https://www.youtube.com/embed/O2VvXh8-umU"
		}
	],
	"djs": [
		{
			"hosts": "DJ Name",
			"photo": "https://randomuser.me/api/portraits/men/1.jpg",
			"picture": {
				"large": "https://randomuser.me/api/portraits/men/1.jpg",
				"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
				"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
			},
			"profile": "DJ profile info to go here.",
			"social": {
				"facebook": "https://www.facebook.com/cliffcentral/",
				"instagram": "https://www.instagram.com/touchhdonline/",
				"twitter": "https://twitter.com/yfm"
			}
		}
	],
	"shows": {
		"mon": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		],
		"tue": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		],
		"wed": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		],
		"thu": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		],
		"fri": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		],
		"sat": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		],
		"sun": [
			{
				"details": "Show details go here. This info shows on the show details page",
				"hosts": "Clyde Smith",
				"photo": "https://randomuser.me/api/portraits/men/1.jpg",
				"picture": {
					"large": "https://randomuser.me/api/portraits/men/1.jpg",
					"medium": "https://randomuser.me/api/portraits/med/men/1.jpg",
					"thumbnail": "https://randomuser.me/api/portraits/thumb/men/1.jpg"
				},
				"profile": "Additional show profile information can be put here, this element should then also be referenced in the app.",
				"show": "The Morning Show",
				"social": {
					"facebook": "https://www.facebook.com/cliffcentral/",
					"instagram": "https://www.instagram.com/touchhdonline/",
					"twitter": "https://twitter.com/TouchHDOnline"
				},
				"time": "06h00 - 09h00"
			}
		]
	},
	"social": [
		{
			"facebook": "https://www.facebook.com/cliffcentral/",
			"googleplus": "https://plus.google.com/+iHeartRadio",
			"instagram": "https://www.instagram.com/touchhdonline/",
			"twitter": "https://twitter.com/Yfm"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/config/schema.json
// module id = 405
// module chunks = 0